module.exports = __webpack_public_path__ + "media/images/group (1)-03a0ce3127ffb57ba2c05543577e537f.svg";